import type { VotingPeriod } from "@book-club/shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { votingQueryKeys } from "@/features/voting/queries/votingQueryKeys";
import votingService from "@/features/voting/services/votingService";

type CancelVotingPeriodVariables = {
    votingPeriodId: string;
};

export function useCancelVotingPeriod() {
    const queryClient = useQueryClient();

    return useMutation<VotingPeriod, Error, CancelVotingPeriodVariables>({
        mutationFn: async (variables) => {
            return await votingService.cancelVotingPeriod(variables);
        },
        onError: (error) => {
            const errorMessage = error instanceof Error ? error.message : "Failed to cancel voting period";
            toast.error(errorMessage);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: votingQueryKeys.periods() });
            toast.success("Voting period cancelled");
        },
    });
}
